module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_glastonbury_sm-b3c1927b70bb2e8fb6995d349feefa8c.png";